import { createSelector } from 'reselect'

import { selectComposedReportState } from './selectComposedReportState'

export const selectGeoSelectValue = createSelector([selectComposedReportState], ({ geo }) => geo)
